// deps
import React, { ReactElement, memo } from "react";

// internal deps
import { AriaHidden } from "@swiggy-private/core-ui";

interface TickIconProps {
    color?: string;
    className?: string;
    height?: number;
    width?: number;
    strokeWidth?: number;
}

const SUPER_ORANGE_COLOR = "#EE4B5E";

const TickIcon = (props: TickIconProps): ReactElement => {
    const { height = 10, width = 12, strokeWidth = 2, color = SUPER_ORANGE_COLOR, className = "" } = props;
    return (
        <AriaHidden as="span">
            <svg
                width={width}
                height={height}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12 12"
                className={className}
            >
                <path d="M1 4.5L4.33333 8L11 1" stroke={color} strokeWidth={strokeWidth} />
            </svg>
        </AriaHidden>
    );
};

export default memo(TickIcon);
